import { Routes } from '@angular/router';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { authGuard } from './core/auth/guards/auth.guard';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { PlanListComponent } from './features/subscription/components/plan-list/plan-list.component';
import { CreateAppoinmentComponent } from './features/dashboard/components/appoinmnet-Booking/create-appoinment/create-appoinment.component';
import { MettingComponent } from './features/jitsi-meeting/component/metting/metting.component';
import { DietSummaryComponent } from './features/user-profile/diet-summury/diet-summary/diet-summary.component';
import { SummuryListComponent } from './features/user-profile/diet-summury/summury-list/summury-list.component';
import { SummuryDetailsComponent } from './features/user-profile/diet-summury/summury-details/summury-details.component';
import { PaymentListComponent } from 'projects/doctor/src/app/features/payment-management/payment-list/payment-list.component';
import { PaymentHistoryComponent } from './features/payment-history/payment-history/payment-history.component';
import { AssessmentDetailsComponent } from './features/assesment-detail/components/assessment-details/assessment-details.component';
import { BmiDetailsComponent } from './features/bmi-details/components/bmi-details/bmi-details.component';
import { HydrationDetailComponent } from './features/hydration-detail/components/hydration-detail/hydration-detail.component';
import { BookingAppoinmentComponent } from './features/dashboard/components/appoinmnet-Booking/booking-appoinment/booking-appoinment.component';
import { PreScoreComponent } from './features/dashboard/components/appoinmnet-Booking/pre-score/pre-score.component';
import { AssessmentHistoryListComponent } from './features/appointment-history/assessment-history-list/assessment-history-list.component';
import { AnswerDetailComponent } from './features/appointment-history/answer-detail/answer-detail.component';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./features/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./features/register/register.component').then((m) => m.RegisterComponent),
  },
  {
    path: 'upgrade-plan',
    pathMatch: 'full',
    component: PlanListComponent,
    canActivate: [authGuard],
  },
  {
    path: 'manage-subscription',
    loadComponent: () =>
      import(
        './features/subscription/components/manage-subscription/manage-subscription.component'
      ).then((m) => m.ManageSubscriptionComponent),
    canActivate: [authGuard],
  },
  {
    path: 'subscription-details',
    loadComponent: () =>
      import(
        './features/subscription/components/subscription-details/subscription-details.component'
      ).then((m) => m.SubscriptionDetailsComponent),
    canActivate: [authGuard],
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      {
        path: 'dashboard',
        component: DashboardComponent,
      },
      {
        path: 'upgrade-plans',
        pathMatch: 'full',
        component: PlanListComponent,
        canActivate: [authGuard],
      },
      {
        path: 'manage-subscriptions',
        loadComponent: () =>
          import(
            './features/subscription/components/manage-subscription/manage-subscription.component'
          ).then((m) => m.ManageSubscriptionComponent),
        canActivate: [authGuard],
      },
      {
        path: 'subscription-detail',
        loadComponent: () =>
          import(
            './features/subscription/components/subscription-details/subscription-details.component'
          ).then((m) => m.SubscriptionDetailsComponent),
        canActivate: [authGuard],
      },
      {
        path: 'plans/checkout/:planId/:durationId',
        loadComponent: () =>
          import('./features/subscription/components/plan-checkout/plan-checkout.component').then(
            (m) => m.PlanCheckoutComponent,
          ),
        canActivate: [authGuard],
      },
      {
        path: 'create-appointment',
        component: BookingAppoinmentComponent,
      },
      {
        path: 'create-score',
        component: PreScoreComponent,
      },
      {
        path: 'schedule-appointment',
        component: CreateAppoinmentComponent,
      },
      {
        path: 'videos',
        loadComponent: () =>
          import('./features/video-module/dashboard/dashboard.component').then(
            (m) => m.DashboardComponent,
          ),
      },
      {
        path: 'video-player',
        loadComponent: () =>
          import('./features/video-module/video-player/video-player.component').then(
            (m) => m.VideoPlayerComponent,
          ),
      },
      {
        path: 'view-all',
        loadComponent: () =>
          import('./features/video-module/view-all-videos/view-all-videos.component').then(
            (m) => m.ViewAllVideosComponent,
          ),
      },
      {
        path: 'diet-logging',
        loadComponent: () =>
          import(
            './features/diet-logging/component/diet-logging-main/diet-logging-main.component'
          ).then((m) => m.DietLoggingMainComponent),
      },
      {
        path: 'recipe-list',
        loadComponent:()=> import('./features/recipes/component/recipe-main/recipe-main.component').then((m) => m.RecipeMainComponent),
      },

      {
        path: 'ingredient-list',
        loadComponent: () =>
          import(
            './features/diet-logging/component/recipe-ingredients-details/recipe-ingredients-details.component'
          ).then((m) => m.RecipeIngredientsDetailsComponent),
      },

      {

        path : 'activity-tracking',
        loadComponent:()=>import('./features/activity-tracking/components/activity-main/activity-main.component').then((m) => m.ActivityMainComponent),
      },

      {
        path: 'create-appointment',
        component: CreateAppoinmentComponent,
      },
      {
        path: 'payment-history',
        component: PaymentHistoryComponent,
      },
      {
        path: 'meeting',
        component: MettingComponent,
      },
      {
        path: 'diet-summary',
        component: DietSummaryComponent,
      },

      {
        path: 'diet-list',
        component: SummuryListComponent,
      },
      {
        path: 'diet-details',
        component: SummuryDetailsComponent,
      },
      {
        path: 'assessment-details',
        component: AssessmentDetailsComponent,
      },
      {
        path: 'preassessment-history',
        component: AssessmentHistoryListComponent,
      },

      {
        path: 'preassessment-details',
        component: AnswerDetailComponent,
      },
      {
        path: 'bmi-details',
        component: BmiDetailsComponent,
      },
      {
        path: 'hydration-details',
        component: HydrationDetailComponent,
      },
      {
        path: 'payment/Success',
        loadComponent: () =>
          import(
            './features/subscription/components/payment-success/payment-success.component'
          ).then((m) => m.PaymentSuccessComponent),
        canActivate: [authGuard],
      },
      {
        path: 'payment/Failure',
        loadComponent: () =>
          import(
            './features/subscription/components/payment-failure/payment-failure.component'
          ).then((m) => m.PaymentFailureComponent),
        canActivate: [authGuard],
      },
      {
        path: 'payment/Pending',
        loadComponent: () =>
          import(
            './features/subscription/components/payment-pending/payment-pending.component'
          ).then((m) => m.PaymentPendingComponent),
        canActivate: [authGuard],
      },

      {
        path: '**',
        loadComponent: () =>
          import('./components/work-in-progress/work-in-progress.component').then(
            (m) => m.WorkInProgressComponent,
          ),
      },
    ],
  },
];
